import { TagDto } from '@sr/dto';
import { tagsApi } from './base';

const _entityTagsApi = tagsApi.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyTags: builder.query<TagDto[], number>({
      query: (companyId: number) => ({
        url: `/company/${companyId}`,
        method: 'GET'
      })
    }),
    useEntitiesTags: builder.query<TagDto[], { ids: number; entityType: string }>({
      query: ({ ids, entityType }) => ({
        url: `/${entityType}`,
        method: 'GET',
        body: { ids, entityType }
      })
    }),
    updateCompanyTags: builder.mutation<TagDto[], { tagIds: number[]; companyId: number }>({
      query: ({ companyId, tagIds }) => ({
        url: `/company/${companyId}`,
        method: 'PUT',
        body: { tags: tagIds }
      })
    })
  })
});

export const entityTagsApi = _entityTagsApi.enhanceEndpoints({
  addTagTypes: ['CompanyTag'],
  endpoints: {
    getCompanyTags: {
      providesTags: (result, error, companyId) =>
        result
          ? [
            ...result.map((tag) => ({ type: 'CompanyTag' as const, id: tag.id })),
            { type: 'CompanyTag', id: `COMPANY-${companyId}` }
          ]
          : [{ type: 'CompanyTag', id: `COMPANY-${companyId}` }]
    },
    updateCompanyTags: {
      invalidatesTags: (result, error, { companyId }) => [
        { type: 'CompanyTag', id: `COMPANY-${companyId}` }
      ]
    }
  }
});

